export const getAvatarUrl = (avatar) => {
  if (avatar) {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return `${baseUrl}/auth/avatars/${avatar}`;
  }
  return null;
};

export const formatDate = (dateString, lang='en-US') => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateString, lang='en-US') => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
